esSizeAdvisorJsonp([1],{

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveEasySizeUserId = saveEasySizeUserId;
exports.getEasySizeUserId = getEasySizeUserId;
exports.recognizeUserType = recognizeUserType;

var _jsCookie = __webpack_require__(5);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _reqwest = __webpack_require__(10);

var _reqwest2 = _interopRequireDefault(_reqwest);

var _utilities = __webpack_require__(2);

var _features = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function saveEasySizeUserId(params, id) {
  if (params.shop.cookies_enabled === false) {
    return;
  }

  (0, _utilities.debug)('[EasySize debug]: Attempting saveEasySizeUserId', id);
  _jsCookie2.default.set('esui', id, { expires: 28, secure: true, sameSite: 'strict' });
}

function getEasySizeUserId(params) {
  var localesid = _jsCookie2.default.get('esui');
  if (localesid && localesid !== '-1') {
    params.easysize.user_id = localesid;
    saveEasySizeUserId(params, localesid);
  } else {
    params.easysize.user_id = params.easysize.uuid;
    saveEasySizeUserId(params, params.easysize.user_id);
  }
  _features.emitter.emit('easysize_user_id_received');
}

function recognizeUserType(params) {
  var urlParameters = (0, _utilities.parseQueryString)(window.location.href.split('?')[1]);

  // If recommended product opened, identify user as returning and select size
  if (urlParameters.hasOwnProperty('es_recommended_size')) {
    params.track(32);
    var currentSize = urlParameters.es_recommended_size;
    var sizeToPreselect = currentSize;

    // If feature enabled, append recommended fit to predicted size
    if (params.features.hasOwnProperty('append_size_with_recommended_fit')) {
      if (params.features.append_size_with_recommended_fit === 'enabled') {
        if (urlParameters.hasOwnProperty('es_recommended_fit')) {
          sizeToPreselect = urlParameters.es_recommended_size + '/' + urlParameters.es_recommended_fit;
          params.easysize.recommended_fit = urlParameters.es_recommended_fit;
        }
      }
    }

    if (params.shop.update_size_dropdown(sizeToPreselect, params)) {
      params.track(7, sizeToPreselect);
      params.track(17, params.product.stock[sizeToPreselect]);
      params.easysize.user_type = 'r';
      params.easysize.calculated_size = urlParameters.es_recommended_size;
      params.easysize.original_calculated_size = {
        size: urlParameters.es_recommended_size,
        predicted_fit: urlParameters.hasOwnProperty('es_recommended_fit') ? urlParameters.es_recommended_fit : '',
        better_matches: [],
        accuracy: {
          'percentage': 100.0,
          'title': 'It\'s a perfect fit!',
          'out_of_5': 5.0,
          'proven_by': 50
        }
      };
      _features.emitter.emit('easysize-size-selected');
      _features.emitter.emit('easysize_user_type_identified', params.easysize.user_type);
      return true;
    }
  }

  if (params.features.returning_user_mode) {
    (0, _utilities.subscribe)('easysize_current_user_size_calculated easysize_returning_user_size_calculated', function () {
      if (params.calculated_size.returning_user && params.calculated_size.current_user) {
        if (params.calculated_size.current_user.sizes.length > 0) {
          var sizeFound = false;

          for (var i = 0; i < params.calculated_size.current_user.sizes.length; i++) {
            var _currentSize = params.calculated_size.current_user.sizes[i];
            var _sizeToPreselect = _currentSize.size;

            // If feature enabled, append recommended fit to predicted size
            if (params.features.hasOwnProperty('append_size_with_recommended_fit')) {
              if (params.features.append_size_with_recommended_fit === 'enabled') {
                if (_currentSize.hasOwnProperty('recommended_fit')) {
                  _sizeToPreselect = _currentSize.size + '/' + _currentSize.recommended_fit;
                  params.easysize.recommended_fit = _currentSize.recommended_fit;
                }
              }
            }

            params.easysize.user_type = 'c';
            params.easysize.calculated_size_proven_by = _currentSize.accuracy.proven_by;
            params.easysize.calculated_size = _currentSize.size;
            params.easysize.original_calculated_size = _currentSize;

            // Sets feature to combine top / bottom recommendations
            if (_currentSize.secondary_size) {
              params.easysize.calculated_size = _currentSize.size + ' / ' + _currentSize.secondary_size;
              _sizeToPreselect = _currentSize.size + ' / ' + _currentSize.secondary_size;
            }

            if (Object.keys(params.product.fits_in_stock).length !== 0) {
              params.track(7, params.easysize.calculated_size);
              sizeFound = true;
              params.track(17, params.product.fits_in_stock[_currentSize.size]);

              if (params.product.fits_in_stock[_currentSize.size] === 0) {
                __webpack_require__.e/* require.ensure */(6).then((function (require) {
                  var addSizeRecommendedText = __webpack_require__(16)("./" + params.easysize.product).addSizeRecommendedText;
                  addSizeRecommendedText('es-recommended', 'returning_user_text_out_of_stock', 'es-recommended-size', params);
                  params.track(21);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              } else if (params.shop.update_size_dropdown(_sizeToPreselect, params)) {
                _features.emitter.emit('easysize-size-selected');
              }

              break;
            } else if (params.product.stock.hasOwnProperty(_currentSize.size)) {
              params.track(7, params.easysize.calculated_size);
              sizeFound = true;
              params.track(17, params.product.stock[_currentSize.size]);

              if (params.product.stock[_currentSize.size] === 0) {
                __webpack_require__.e/* require.ensure */(6/* duplicate */).then((function (require) {
                  var addSizeRecommendedText = __webpack_require__(16)("./" + params.easysize.product).addSizeRecommendedText;
                  addSizeRecommendedText('es-recommended', 'returning_user_text_out_of_stock', 'es-recommended-size', params);
                  params.track(21);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              } else if (params.shop.update_size_dropdown(_sizeToPreselect, params)) {
                _features.emitter.emit('easysize-size-selected');
              }

              break;
            } else if (params.features.hasOwnProperty('ignore_stock_check')) {
              // Feature to ignore stock check and call update size dropdown method anyways.
              // Tailored for shops selling one size clothing

              params.track(7, params.easysize.calculated_size);
              sizeFound = true;
              if (params.product.stock.hasOwnProperty(_currentSize.size)) {
                params.track(17, params.product.stock[_currentSize.size]);
              } else {
                params.track(21);
              }
              if (params.shop.update_size_dropdown(_sizeToPreselect, params)) {
                _features.emitter.emit('easysize-size-selected');
              }
            }
          }

          if (!sizeFound) {
            params.track(22, params.calculated_size.current_user.sizes.map(function (el) {
              return el.size;
            }).join(','));
          }
        } else if (params.calculated_size.returning_user.sizes.length > 0) {
          var _sizeFound = false;
          for (var _i = 0; _i < params.calculated_size.returning_user.sizes.length; _i++) {
            var _currentSize2 = params.calculated_size.returning_user.sizes[_i];
            var _sizeToPreselect2 = _currentSize2.size;

            // If feature enabled, append recommended fit to predicted size
            if (params.features.hasOwnProperty('append_size_with_recommended_fit')) {
              if (params.features.append_size_with_recommended_fit === 'enabled') {
                if (_currentSize2.hasOwnProperty('recommended_fit')) {
                  _sizeToPreselect2 = _currentSize2.size + '/' + _currentSize2.recommended_fit;
                  params.easysize.recommended_fit = _currentSize2.recommended_fit;
                }
              }
            }

            params.easysize.user_type = 'r';
            params.easysize.calculated_size_proven_by = _currentSize2.accuracy.proven_by;
            params.easysize.calculated_size = _currentSize2.size;
            params.easysize.original_calculated_size = _currentSize2;

            // Sets feature to combine top / bottom recommendations
            if (_currentSize2.secondary_size) {
              params.easysize.calculated_size = _currentSize2.size + ' / ' + _currentSize2.secondary_size;
              _sizeToPreselect2 = _currentSize2.size + ' / ' + _currentSize2.secondary_size;
            }

            (0, _utilities.debug)('ES', 'pre logic');
            if (Object.keys(params.product.fits_in_stock).length !== 0) {
              (0, _utilities.debug)('ES fits_in_stock', 7, _currentSize2.size);
              params.track(7, params.easysize.calculated_size);
              _sizeFound = true;
              params.track(17, params.product.fits_in_stock[_currentSize2.size]);

              if (params.product.fits_in_stock[_currentSize2.size] === 0) {
                __webpack_require__.e/* require.ensure */(6/* duplicate */).then((function (require) {
                  var addSizeRecommendedText = __webpack_require__(16)("./" + params.easysize.product).addSizeRecommendedText;
                  addSizeRecommendedText('es-recommended', 'returning_user_text_out_of_stock', 'es-recommended-size', params);
                  params.track(21);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                params.shop.update_size_dropdown(_sizeToPreselect2, params);
              } else if (params.shop.update_size_dropdown(_sizeToPreselect2, params)) {
                _features.emitter.emit('easysize-size-selected');
              }

              break;
            } else if (params.product.stock.hasOwnProperty(_currentSize2.size)) {
              (0, _utilities.debug)('ES stock', 7, _currentSize2.size);
              (0, _utilities.debug)(params);
              (0, _utilities.debug)(params.track);
              params.track(7, params.easysize.calculated_size);
              _sizeFound = true;
              params.track(17, params.product.stock[_currentSize2.size]);

              if (params.product.stock[_currentSize2.size] === 0) {
                __webpack_require__.e/* require.ensure */(6/* duplicate */).then((function (require) {
                  var addSizeRecommendedText = __webpack_require__(16)("./" + params.easysize.product).addSizeRecommendedText;
                  addSizeRecommendedText('es-recommended', 'returning_user_text_out_of_stock', 'es-recommended-size', params);
                  (0, _utilities.debug)(params);
                  (0, _utilities.debug)(params.track);
                  params.track(7, params.easysize.calculated_size);
                  params.track(21);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                params.shop.update_size_dropdown(_sizeToPreselect2, params);
              } else if (params.shop.update_size_dropdown(_sizeToPreselect2, params)) {
                _features.emitter.emit('easysize-size-selected');
              }

              break;
            } else if (params.features.hasOwnProperty('ignore_stock_check')) {
              // Feature to ignore stock check and call update size dropdown method anyways.
              // Tailored for shops selling one size clothing

              params.track(7, params.easysize.calculated_size);
              _sizeFound = true;
              if (params.product.stock.hasOwnProperty(_currentSize2.size)) {
                params.track(17, params.product.stock[_currentSize2.size]);
              } else {
                params.track(21);
              }
              if (params.shop.update_size_dropdown(_sizeToPreselect2, params)) {
                _features.emitter.emit('easysize-size-selected');
              }
            }
          }

          if (!_sizeFound) {
            params.track(22, params.calculated_size.returning_user.sizes.map(function (el) {
              return el.size;
            }).join(','));
          }
        }

        /*
                Brand similarity is used when this header is present.
                The response headers are saved into global variable, in order to access it after pageview id is retrieved]
                 */

        if (params.easysize.response_headers.indexOf('mse: True') !== -1 && params.easysize.response_headers.indexOf('dse: True') !== -1) {
          params.track(34, 'dse-mse');
        } else if (params.easysize.response_headers.indexOf('mse: True') !== -1) {
          params.track(34, 'mse');
        } else if (params.easysize.response_headers.indexOf('dse: True') !== -1) {
          params.track(34, 'dse');
        }

        _features.emitter.emit('easysize_user_type_identified', params.easysize.user_type);
      }
    });

    getSizeForLoggedInUser(params, function (data) {
      if (Object.keys(params.product.fits_in_stock).length !== 0 && data.sizes.length > 0) {
        var recommendedSizeIndex = 0;

        for (var i = 0; i < data.sizes.length; i++) {
          if (params.product.fits_in_stock.hasOwnProperty(data.sizes[i].recommended_fit) && params.product.fits_in_stock[data.sizes[i].recommended_fit].hasOwnProperty(data.sizes[i].size)) {
            recommendedSizeIndex = i;
            break;
          }
        }

        (0, _utilities.debug)('Based on fits in stock', data.sizes[recommendedSizeIndex]);
        params.calculated_size.current_user = {
          sizes: [data.sizes[recommendedSizeIndex]]
        };
      } else if (params.product.available_fits && params.product.available_fits.length > 0 && data.sizes.length > 0) {
        var _recommendedSizeIndex = 0;

        if (params.product.available_fits && data.sizes.length > 1) {
          for (var _i2 = 0; _i2 < data.sizes.length; _i2++) {
            if (params.product.available_fits.indexOf(data.sizes[_i2].recommended_fit) !== -1) {
              _recommendedSizeIndex = _i2;
              break;
            }
          }
        }

        params.calculated_size.current_user = {
          sizes: [data.sizes[_recommendedSizeIndex]]
        };
      } else {
        params.calculated_size.current_user = {
          sizes: data.sizes
        };
      }

      _features.emitter.emit('easysize_current_user_size_calculated');
    });

    getSizeForReturningUser(params, function (data) {
      if (Object.keys(params.product.fits_in_stock).length !== 0 && data.sizes.length > 0) {
        var recommendedSizeIndex = 0;

        for (var i = 0; i < data.sizes.length; i++) {
          if (params.features.check_fit_stock) {
            var s = data.sizes[i].size;
            var f = false;

            if (params.product.available_lengths.indexOf(data.sizes[i].recommended_length) !== -1) {
              f = data.sizes[i].recommended_length;
            }

            if (params.product.available_fits.indexOf(data.sizes[i].recommended_fit) !== -1) {
              f = data.sizes[i].recommended_fit;
            }

            var combined_size = params.features.check_fit_stock.replace('{s}', s).replace('{f}', f);

            if (f) {
              data.sizes[i].size = params.features.check_fit_stock.replace('{s}', s).replace('{f}', f);
              data.sizes[i].recommended_length = null;
              data.sizes[i].recommended_fit = null;
              recommendedSizeIndex = i;
              break;
            }
          } else if (params.product.fits_in_stock.hasOwnProperty(data.sizes[i].recommended_fit) && params.product.fits_in_stock[data.sizes[i].recommended_fit].hasOwnProperty(data.sizes[i].size)) {
            recommendedSizeIndex = i;
            break;
          }
        }

        console.log('Based on fits in stock', data.sizes[recommendedSizeIndex]);
        params.calculated_size.returning_user = {
          sizes: [data.sizes[recommendedSizeIndex]]
        };
      } else if (params.product.available_fits && params.product.available_fits.length > 0 && data.sizes.length > 0) {
        var _recommendedSizeIndex2 = 0;

        if (params.product.available_fits && data.sizes.length > 1) {
          for (var _i3 = 0; _i3 < data.sizes.length; _i3++) {
            if (params.product.available_fits.indexOf(data.sizes[_i3].recommended_fit) !== -1) {
              _recommendedSizeIndex2 = _i3;
              break;
            }
          }
        }

        console.log('Based on available fits', data.sizes[_recommendedSizeIndex2]);
        params.calculated_size.returning_user = {
          sizes: [data.sizes[_recommendedSizeIndex2]]
        };
      } else {
        params.calculated_size.returning_user = {
          sizes: data.sizes
        };
      }

      _features.emitter.emit('easysize_returning_user_size_calculated');
    });
  } else {
    (0, _utilities.debug)('[EasySize debug]: Returning user mode disabled');
    _features.emitter.emit('easysize_user_type_identified', params.easysize.user_type);
  }
}

function getSizeForLoggedInUser(params, callback) {
  callback({ sizes: [] }); // eslint-disable-line
  return;
  // if (params.shop.user_id === -1) {
  //   return
  // }

  var formData = {
    'product_type': params.product.category_id,
    'product_gender': params.product.gender,
    'product_brand': params.product.brand_id,
    'sizes_in_stock': JSON.stringify(params.product.stock),
    'fit_variants': JSON.stringify(params.product.available_fits),
    'length_variants': JSON.stringify(params.product.available_lengths),
    'user_id': params.shop.user_id
  };

  if (params.product.fit_id !== -1) {
    formData.product_fit = params.product.fit_id;
  }
  if (params.product.model) {
    formData.product_model = params.product.model;
  }
  if (params.product.sku) {
    formData.product_sku = params.product.sku;
  }

  (0, _reqwest2.default)({
    url: '' + params.easysize.api_url + params.shop.generated_shop_id + '/size/get_size_with_user/',
    method: 'GET',
    data: formData,
    error: function error(resp) {
      (0, _utilities.debug)('[EasySize debug]: Error getting size for logged in user');
    },
    success: function success(resp) {
      if (resp.status_code) {
        (0, _utilities.debug)('[EasySize debug]: EasySize size failed to calculate with [' + resp.status_code + '] ' + resp.error);
      } else {
        callback(resp);
      }
    }
  });
}

function getSizeForReturningUser(params, callback) {
  var formData = {
    'product_type': params.product.category_id,
    'product_gender': params.product.gender,
    'product_brand': params.product.brand_id,
    'sizes_in_stock': JSON.stringify(params.product.stock),
    'fit_variants': JSON.stringify(params.product.available_fits),
    'length_variants': JSON.stringify(params.product.available_lengths),
    'easysize_user': params.easysize.user_id
  };

  if (params.product.fit_id !== -1) {
    formData.product_fit = params.product.fit_id;
  }
  if (params.product.model) {
    formData.product_model = params.product.model;
  }
  if (params.product.sku) {
    formData.product_sku = params.product.sku;
  }

  var r = (0, _reqwest2.default)({
    url: '' + params.easysize.api_url + params.shop.generated_shop_id + '/size/get_size_with_orders/',
    method: 'GET',
    data: formData,
    error: function error(resp) {
      (0, _utilities.debug)('[EasySize debug]: Error getting size for returning user');
    },
    success: function success(resp) {
      if (resp.status_code) {
        (0, _utilities.debug)('[EasySize debug]: EasySize size failed to calculate with [' + resp.status_code + '] ' + resp.error);
      } else {
        params.easysize.response_headers = r.request.getAllResponseHeaders();
        callback(resp);
      }
    }
  });
}

/***/ })

});


// WEBPACK FOOTER //
// chunks/easysize.d15b1cc24a60222062fd.js